<ion-header><app-custom-header></app-custom-header></ion-header>
<ion-content  padding style="background-color: #f4f4f4; padding-left: 30px;">
  <div class="dec1">Nos formules d'abonnement</div>
  <div class="dec" *ngIf = "this.hideText()">Jusqu'au 31 décembre seulement!</div>
  <div class="hhh">
	  <ion-card>
	  		<ion-card-header>100% DIGITAL</ion-card-header>
		    <ion-card-content>
		    	<div class="best-offer"> LA MEILLEURE OFFRE!</div>
		    	<div class="image"><img src="../assets/img/offer-devices.png"></div>
		    	<div class="hline"></div>
		    	<ion-grid>
		    		<ion-row>
		    			<ion-col class="first">
		    				<span class="cost">8 &euro;</span>
		    			</ion-col>
		    			<ion-col>
		    				<div class="permonth">
		    					<span class="plus">par mois</span>
		    				</div>
		    				<div class="reduction">
		    					<span class="old-price">17,50&euro;</span>
		    					<span class="reduct">-54%</span>
		    				</div>
		    			</ion-col>
		    		</ion-row>
		    	</ion-grid>
		    	<div class="offer-button">
		    		<div class="basket"></div><div class="offer-button-text" (click)="open('https://www.playbacpresse.fr/modules/boutique/panier/mod_pan.php?type=ajout&id=3195?utm_source=website&utm_medium=landingpage_offer&utm_content=digital_subscription')">JE M'ABONNE</div>
		    	</div>
		    </ion-card-content>
		    <div class="card-footer" (click) = "content = !content">
		    	<div class="footer-text" *ngIf="!content">Plus de détails</div>
		    	<div class="footer-text"  *ngIf="content">Moins de détails</div>
		    	<div class="down-icon">
		    		<ion-icon name="arrowdownopen" *ngIf="!content"></ion-icon>
		    		<ion-icon name="arrowupclosed" *ngIf="content"></ion-icon>
		    	</div>
			</div>
		    <div [ngClass]= "{'card-footer-extend': true, 'open': content}">
		    	<div class = "part">
			    	<p class="head"><span class="it">Le Petit Quotidien</span> Digital</p>
			    	<p>Accès illimité au journal Digital (incluant PDF et audio).</p>
		    	</div>
		    	<div class="last-part">
			    	<p class="head">Le Cartable Digital</p>
			    	<p>Accès illimité au Cartable Digital:</p>
			    	<ul>
				    	<li>- Les fiches exposés.</li>
				    	<li>- Les dossiers d'actualité.</li>
				    	<li>- Toutes les archives.</li>
			    	</ul>
		    	</div>
		    </div>
	  </ion-card>
	    <ion-card>
	  		<ion-card-header>100% PAPIER</ion-card-header>
		    <ion-card-content class="white">
		    	<div class="image"><img src="../assets/img/3papers.png"></div>
		    	<div class="hline grey"></div>
		    	<ion-grid>
		    		<ion-row>
		    			<ion-col class="first">
		    				<span class="cost2">8.99 &euro;</span>
		    			</ion-col>
		    			<ion-col>
		    				<div class="permonth">
		    					<span class="plus">par mois</span>
		    				</div>
		    				<div class="reduction">
		    					<span class="old-price">12,50&euro;</span>
		    					<span class="reduct">-28%</span>
		    				</div>
		    			</ion-col>
		    		</ion-row>
		    	</ion-grid>
		    	<div class="offer-button">
		    		<div class="basket"></div><div class="offer-button-text" (click)="open('https://www.playbacpresse.fr/modules/boutique/panier/mod_pan.php?type=ajout&id=2504?utm_source=website&utm_medium=landingpage_offer&utm_content=paper_subscription')">JE M'ABONNE</div>
		    	</div>
		    </ion-card-content>
		    <div class="card-footer" (click) = "content3 = !content3">
		    	<div class="footer-text" *ngIf="!content3">Plus de détails</div>
		    	<div class="footer-text" *ngIf="content3">Moins de détails</div>
		    	 <div class="down-icon">
		    		<ion-icon name="arrowdownopen" *ngIf="!content3"></ion-icon>
		    		<ion-icon name="arrowupclosed" *ngIf="content3"></ion-icon>
		    	 </div>
	    	</div>
		    <div [ngClass]= "{'card-footer-extend': true, 'open': content3}">
		    	<div class="last-part">
			    	<p class="head"><span class="it">Le Petit Quotidien</span> Papier</p>
			    	<p>Chaque jour, du lundi au samedi, le journal dans votre boîte aux lettres.</p>
		    	</div>
		    </div>
	  </ion-card>
	      <ion-card>
	  		<ion-card-header>PAPIER + DIGITAL</ion-card-header>
		    <ion-card-content class="white">
		    	<div class="image"><img src="../assets/img/paper&digital.png"></div>
		    	<div class="hline grey"></div>
		    	<ion-grid>
		    		<ion-row>
		    			<ion-col class="first">
		    				<span class="cost2">10.99 &euro;</span>
		    			</ion-col>
		    			<ion-col>
		    				<div class="permonth">
		    					<span class="plus">par mois</span>
		    				</div>
		    				<div class="reduction">
	    						<span class="old-price">17,50&euro;</span>
	    						<span class="reduct">-37%</span>
	    					</div>
	    				</ion-col>
	    			</ion-row>
	    		</ion-grid>
		    	<div class="offer-button">
		    		<div class="basket"></div><div class="offer-button-text" (click)="open('https://www.playbacpresse.fr/modules/boutique/panier/mod_pan.php?type=ajout&id=2506?utm_source=website&utm_medium=landingpage_offer&utm_content=paperdigital_subscription')">JE M'ABONNE</div>
		    	</div>
		    </ion-card-content>
		    <div class="card-footer" (click) = "content2 = !content2">
		    	<div class="footer-text" *ngIf="!content2">Plus de détails</div>
		    	<div class="footer-text" *ngIf="content2">Moins de détails</div>
		    	<div class="down-icon">
		    		<ion-icon name="arrowdownopen" *ngIf="!content2"></ion-icon>
		    		<ion-icon name="arrowupclosed" *ngIf="content2"></ion-icon>
		    	</div>
			</div>
		    <div [ngClass]= "{'card-footer-extend': true, 'open': content2}">
		    	<div class = "part">
			    	<p class="head"><span class="it">Le Petit Quotidien</span> Papier</p>
			    	<p>Chaque jour, du lundi au samedi, le journal dans votre boîte aux lettres.</p>
		    	</div>
		    	<div class="part">
			    	<p class="head"><span class="it">Le Petit Quotidien</span> Digital</p>
			    	<p>Accès illimité au journal Digital (incluant PDF et audio).</p>
		    	</div>
		    	<div class="last-part">
			    	<p class="head">Le cartable digital</p>
			    	<p>Accès illimité au Cartable Digital:</p>
			    	<ul>
				    	<li>- Les fiches exposés.</li>
				    	<li>- Les dossiers d'actualité.</li>
				    	<li>- Toutes les archives.</li>
			    	</ul>
		    	</div>
		    </div>
			</ion-card>
	</div>
	<div class="pp">
		    <img class="abo" src="../assets/img/2abo.png">
	</div>
	<div class="hhh">
		<div class="formulas">NOS AUTRES FORMULES</div>
		    <div class="kk">
			    <p class="dd"><ion-icon name="boutique"></ion-icon>Toutes Nos Formules</p>
			    <p><ion-icon name="arrow-right-full"></ion-icon> <span class="more" (click)="open('https://www.playbacpresse.fr/boutique.97.les-abonnements-au-petit-quotidien.php#formules?track=PBSI0453&utm_source=website&utm_medium=landingpage_offer&utm_content=view_all')">En savoir plus</span></p>
			</div>
	 </div>
  <app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer>
	<app-bottom-menu></app-bottom-menu>
</ion-footer>
